import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchGPBasedOnOrdersApi,
  GPHierarchyNode,
} from "../../api/gpHierarchy.api";

export interface GPHierarchyState {
  hierarchy: GPHierarchyNode[];
  loading: boolean;
  error: string | null;
}

const initialState: GPHierarchyState = {
  hierarchy: [],
  loading: false,
  error: null,
};

export const fetchGPBasedOnOrders = createAsyncThunk<
  GPHierarchyNode[],
  {
    fromDate: string;
    toDate: string;
    selectedUserIds?: string[];
    deselectedUserIds?: string[];
  },
  { rejectValue: string }
>(
  "gpHierarchy/fetchBasedOnOrders",
  async (
    { fromDate, toDate, selectedUserIds, deselectedUserIds },
    { rejectWithValue },
  ) => {
    try {
      const res = await fetchGPBasedOnOrdersApi({
        fromDate,
        toDate,
        selectedUserIds,
        deselectedUserIds,
      });
      return res.data.hierarchy;
    } catch (err: any) {
      return rejectWithValue(
        err.message || "Failed to fetch GP based on orders",
      );
    }
  },
);

const gpHierarchySlice = createSlice({
  name: "gpHierarchy",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGPBasedOnOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGPBasedOnOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.hierarchy = action.payload;
      })
      .addCase(fetchGPBasedOnOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Unknown error";
      });
  },
});

export const { clearError } = gpHierarchySlice.actions;
export default gpHierarchySlice.reducer;
